import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { MediaImage } from '@/components/generals/media-image'

const FIGURES = [
    { label: 'Founded in Paris', value: '1948' },
    { label: 'Artisans', value: '214' },
    { label: 'Hours per Odile bag', value: '18' }
]

export const SavoirFaireTeaser: FC = (): ReactNode => {
    return (
        <section id='savoir-faire' aria-labelledby='savoir-faire-title' className='bg-muted'>
            <div className='mx-auto grid max-w-[1600px] lg:grid-cols-12'>
                <div className='relative aspect-[4/3] lg:col-span-7 lg:aspect-auto lg:min-h-[720px]'>
                    <MediaImage
                        src='/images/home/savoir-faire.jpg'
                        alt='An artisan in a canvas apron marking out a pattern on a long cutting table in a bright atelier'
                        sizes='(min-width: 1024px) 58vw, 100vw'
                        className='object-cover'
                    />
                </div>

                <div className='reveal flex flex-col justify-center px-6 py-16 sm:px-10 lg:col-span-5 lg:px-16 lg:py-24'>
                    <p className='eyebrow text-muted-foreground'>
                        Savoir-faire
                    </p>

                    <h2 id='savoir-faire-title' className='mt-5 font-heading text-4xl font-light leading-[1.05] sm:text-5xl'>
                        Eighteen hours, one pair of hands
                    </h2>

                    <p className='mt-6 text-[15px] leading-relaxed text-muted-foreground'>
                        Every Odile bag is made from start to finish by a single artisan in our Normandy ateliers. The calfskin is chosen hide by hide, cut by hand, saddle-stitched with two needles and signed inside before it leaves the bench. When it needs care, it returns to the same atelier, for life.
                    </p>

                    <dl className='mt-10 grid grid-cols-3 gap-6 border-t border-foreground/15 pt-8'>
                        {FIGURES.map(figure => (
                            <div key={figure.label} className='flex flex-col-reverse gap-2'>
                                <dt className='text-xs leading-snug text-muted-foreground'>
                                    {figure.label}
                                </dt>

                                <dd className='font-heading text-4xl font-light'>
                                    {figure.value}
                                </dd>
                            </div>
                        ))}
                    </dl>

                    <Link href='/maison#savoir-faire' className='eyebrow link-underline mt-12 self-start'>
                        Inside the ateliers
                    </Link>
                </div>
            </div>
        </section>
    )
}
